if (!customElements.get('product-addons')) {
  customElements.define(
    'product-addons',
    class ProductAddons extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-pa-track]');
        this.prevBtn = this.querySelector('[data-pa-prev]');
        this.nextBtn = this.querySelector('[data-pa-next]');
        this.selectedIds = new Set();

        if (!this.track) return;

        this.onScroll = () => this.updateArrows();
        this.onResize = () => this.updateArrows();
        this.onPrev = () => this.scrollByCard(-1);
        this.onNext = () => this.scrollByCard(1);
        this.onToggle = (event) => this.toggleAddon(event.currentTarget);

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
        if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);

        this.querySelectorAll('[data-pa-toggle]').forEach((button) => {
          button.addEventListener('click', this.onToggle);
        });

        this.updateArrows();
      }

      disconnectedCallback() {
        if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
        if (this.onResize) window.removeEventListener('resize', this.onResize);
        if (this.prevBtn && this.onPrev) this.prevBtn.removeEventListener('click', this.onPrev);
        if (this.nextBtn && this.onNext) this.nextBtn.removeEventListener('click', this.onNext);
        this.querySelectorAll('[data-pa-toggle]').forEach((button) => {
          if (this.onToggle) button.removeEventListener('click', this.onToggle);
        });
      }

      toggleAddon(button) {
        const variantId = button.dataset.variantId;
        if (!variantId || button.disabled) return;

        const card = button.closest('[data-pa-card]');
        const addLabel = button.querySelector('[data-pa-add-label]');
        const addedLabel = button.querySelector('[data-pa-added-label]');
        const isSelected = this.selectedIds.has(variantId);

        if (isSelected) {
          this.selectedIds.delete(variantId);
          button.setAttribute('aria-pressed', 'false');
          if (card) card.classList.remove('is-selected');
          if (addLabel) addLabel.hidden = false;
          if (addedLabel) addedLabel.hidden = true;
        } else {
          this.selectedIds.add(variantId);
          button.setAttribute('aria-pressed', 'true');
          if (card) card.classList.add('is-selected');
          if (addLabel) addLabel.hidden = true;
          if (addedLabel) addedLabel.hidden = false;
        }
      }

      getSelectedItems() {
        return Array.from(this.selectedIds).map((id) => ({
          id: Number(id),
          quantity: 1,
        }));
      }

      scrollByCard(direction) {
        const card = this.track.querySelector('[data-pa-card]');
        if (!card) return;
        const styles = window.getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 8;
        this.track.scrollBy({
          left: direction * (card.getBoundingClientRect().width + gap),
          behavior: 'smooth',
        });
      }

      updateArrows() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const canScroll = maxScroll > 4;
        this.classList.toggle('is-scrollable', canScroll);
        if (this.prevBtn) this.prevBtn.disabled = !canScroll || this.track.scrollLeft <= 4;
        if (this.nextBtn) this.nextBtn.disabled = !canScroll || this.track.scrollLeft >= maxScroll - 4;
      }
    }
  );
}
